import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { select_reservation_detail } from "../../Axios";
import * as S from "../../style/StyleComponentSection";
import * as M from "../../style/StyleComponentMain";
import theme from "../../style/theme";
import { get_day_timestamp } from "../../Validation";

interface ReservationList {
    construction_reservation_ID                : string;
    construction_reservation_progress          : number;
    construction_reservation_progress_name     : string;
    construction_reservation_division          : number;
    construction_reservation_division_name     : string;
    construction_reservation_name              : string;
    construction_reservation_big_area          : string;
    construction_reservation_small_area        : string;
    construction_reservation_before_big_area   : string;
    construction_reservation_before_small_area : string;
    construction_reservation_reservationTime   : Date;
    construction_reservation_time_name         : string;
};

const lightGray02     = theme.colors.lightGray02;
const middleGray02     = theme.colors.middleGray02;
const pointYellow  = theme.colors.pointYellow;
const mainBlack = theme.colors.mainBlack

const ReservationDetailSummary:React.FC = () => {
    const customerData = useSelector((state: RootState) => state.customerData);
    const [reservationList, setReservationList] = useState<ReservationList[]>([]);

    useEffect(() => {
        if(!customerData.customer_ID) return;
        select_reservation_detail(customerData.customer_ID, 0, 10, 1, 0, 0).then(result => {
            let list = [...result.rows]
            setReservationList(list.slice(0, 4));
        })
    }, [customerData.customer_ID]);

    const payStatusBackground = (status: number) => {
        switch (status) {
            case 1 : return lightGray02; // 매칭 중
            case 2 : return middleGray02; // 결제 대기
            case 3 : return pointYellow; // 결제 완료
            case 4 : return mainBlack
            default : return "";
        }
    };

    const payStatusColor = (status: number) => {
        switch (status) {
            case 1 : return mainBlack;
            case 2 : return mainBlack;
            case 3 : return mainBlack;
            case 4 : return "#fff";
            default : return mainBlack;
        }
    };

    return (
        <div className="mt-5 w-[100%]">
            <S.ReservationTableHead style={{borderTop : `0.5px solid ${middleGray02}`, borderBottom : `0.5px solid ${middleGray02}`, padding : "8px 0", cursor : "default"}}>
                <div className="w-20 lg:w-16">진행상태</div>
                <div className="w-16">구분</div>
                <div className="w-14">예약번호</div>
                <div className="w-14">고객명</div>
                <div className="w-28 lg:w-36">시공주소</div>
                <div className="w-20">시공예약일자</div>
                <div className="w-12">시간</div>
            </S.ReservationTableHead>

            <div>
                {reservationList.map((tmp, idx) => 
                    <M.ReservationSummaryTableBody key={tmp.construction_reservation_ID}>
                        <div 
                            className="pay-status-box w-20 lg:w-16"
                            style={{
                                backgroundColor : `${payStatusBackground(tmp.construction_reservation_progress)}`,
                                color : `${payStatusColor(tmp.construction_reservation_progress)}`,
                                border : `${tmp.construction_reservation_progress === 5 ? "0.5px solid #A1A1AA" : ""}`
                            }}
                        >
                            {tmp.construction_reservation_progress_name}
                        </div>
                        <div className="w-16">{tmp.construction_reservation_division_name}</div>
                        <div className="w-14">{tmp.construction_reservation_ID}</div>
                        <div className="w-14 text-ellipsis whitespace-nowrap overflow-hidden">{tmp.construction_reservation_name}</div>
                        <div className={`w-28 lg:w-36 h-[25px] text-ellipsis whitespace-nowrap overflow-hidden ${tmp.construction_reservation_division === 3 ? "" : "leading-[25px]"}`}>
                            <p>{tmp.construction_reservation_big_area + " " + tmp.construction_reservation_small_area}</p>
                            {tmp.construction_reservation_division === 3 && <p className="text-[12px] text-[#7B7D81] leading-[17px]">(이동 : {tmp.construction_reservation_before_big_area + " " + tmp.construction_reservation_before_small_area})</p>}
                        </div>
                        <div className="w-20">{get_day_timestamp(tmp.construction_reservation_reservationTime).year_month_day}</div>
                        <div className="w-12">{tmp.construction_reservation_time_name}</div>
                    </M.ReservationSummaryTableBody>
                )}
            </div>
        </div>
    )
};

export default ReservationDetailSummary;